<template>
  <section>
    <header class="header-image ken-burn-center light" data-parallax="true"
            data-natural-height="500" data-natural-width="1920" data-bleed="0"
            data-image-src="../media/header1_wise.jpg" data-offset="0">
      <div class="container">
        <h1>WISE</h1>
        <h2>AUTOTRANSFORMADORES</h2>
      </div>
    </header>
    <main>
      <section class="section-base">
        <div class="container">
          <div class="row row-fit-lg">
            <div class="col-lg-12">
              <p align="justify">
                A WISE Transformadores está localizada em Jaraguá do Sul, no estado de Santa
                Catarina, dedicando-se a fabricação de transformadores a seco para o mercado
                nacional e internacional desde 1994. Utilizando tecnologia de ponta, com avançados
                equipamentos e processos de fabricação, destaca-se pela qualidade e confiabilidade
                dos seus produtos.
                <br><br>
                &nbsp;&nbsp;Com constantes investimentos em infraestrutura, treinamento e
                qualificação de seus colaboradores e um sistema de gestão da qualidade, conta hoje,
                com uma linha de produtos que compreende a fabricação de transformadores,
                autotransformadores e reatâncias monofásicos e trifásicos a seco, com potência até
                1000kVA.
              </p>
              <img :src="require('Assets/images/photo_wise1.jpg')">
            </div>
          </div>
        </div>
      </section>
      <MarcasParceiras></MarcasParceiras>
      <br><br>
    </main>
  </section>
</template>

<script>
import MarcasParceiras from 'Homepage/common/MarcasParceiras.vue';

export default {
  name: 'Wise',
  components: {
    MarcasParceiras,
  },
};
</script>

<style scoped>
header {
  height: 250px !important;
  background-image: url("../../assets/images/header1_wise.jpg");
}
header .container {
  padding-top: 50px !important;
}
header h2 {
  color: #0098da !important;
  line-height: 37px;
  text-transform: uppercase !important;
  font-weight: 700 !important;
  margin: 0 !important;
  font-size: 14px !important;
}

</style>
